export const useNavigation = () => undefined;
//# sourceMappingURL=use-navigation.web.js.map